
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const logo = {
  dark: require("./assets/images/abdulify-mini.png"),
  light: require("./assets/images/abdulify-mini-light.png"),
}



const greeting = {
  /* Your Summary And Greeting Section */
  username: "Abdul",
  title: "Hi, I'm Abdullahi",
  subTitle: `I’m a software engineer with 10 years of experience delivering scalable products across web, mobile, and cloud platforms, with a strong background in fintech. I’m driven by building technology that simplifies life and creates real impact. Outside work, I enjoy football, reading, and exploring robotics and AGI.`,
  resumeLink: "https://drive.google.com/file/d/1uU38VaVELmKKCGJ4johEe8lmW-bXafpE/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/benyusouf",
  linkedin: "https://www.linkedin.com/in/benyusouf/",
  gmail: "abdul.benyusouf@gmail.com",
  gitlab: "https://gitlab.com/benyusouf",
  facebook: "https://www.facebook.com/benyusouf",
  medium: "https://medium.com/@benyusouf",
  stackoverflow: "https://stackoverflow.com/users/5317436/benyusouf",
  instagram: "https://instagram.com/benyusouf",
  twitter: "https://x.com/benyusouf",
  whatsapp: "https://wa.me/2348060881434"
};

// Your Skills Section

const skillsSection = {
  title: "Languages and tools I use",
  title2: "What I do",
  subTitle: "Because it\'s a passion, I never stop learning and I love exploring new technologies",
  skills: [
    emoji("⚡ Build, monitor and maintain robust APIs that solve various business needs."),
    emoji("⚡ Develop highly interactive interfaces for web and mobile applications."),
    emoji("⚡ Automate and simplify application build, test, and deployment using DevOps tools and technologies."),
    emoji("⚡ Build cloud and serverless aplications leveraging on cloud services on Azure, AWS and GCP."),
    emoji("⚡ Organize meetups, workshops and other events for tech communities."),
    emoji("⚡ Mentor beginer and junior developers in related technical fields.")
    
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "ReactJs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "NodeJs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    }
  ]
};

const moreSkills = {
  skills: [
    {
      image: require("./assets/images/csharp.svg"),
      name: 'C#'
    },
    {
      image: require("./assets/images/dotnet.svg"),
      name: 'Dotnet'
    },
    {
      image: require("./assets/images/java.svg"),
      name: 'Java'
    },
    {
      image: require("./assets/images/python.svg"),
      name: 'Python'
    },
    {
      image: require("./assets/images/mongoDb.svg"),
      name: 'MongoDb'
    },
    {
      image: require("./assets/images/sqlserver.svg"),
      name: 'MSSQL Server'
    },
    {
      image: require("./assets/images/mysql.svg"),
      name: 'MySQL'
    },
    {
      image: require("./assets/images/firebase.svg"),
      name: 'Firebase'
    },
    {
      image: require("./assets/images/android.svg"),
      name: 'Android'
    },
    {
      image: require("./assets/images/js.svg"),
      name: 'Javascript'
    },
    {
      image: require("./assets/images/node.svg"),
      name: 'Node JS'
    },
    {
      image: require("./assets/images/angular.svg"),
      name: 'Angular'
    },
    {
      image: require("./assets/images/react.svg"),
      name: 'React'
    },
    {
      image: require("./assets/images/html.svg"),
      name: 'HTML5'
    },
    {
      image: require("./assets/images/css.svg"),
      name: 'CSS3'
    },
    {
      image: require("./assets/images/azure.svg"),
      name: 'Azure'
    },
    {
      image: require("./assets/images/aws.svg"),
      name: 'AWS'
    },
    {
      image: require("./assets/images/google.svg"),
      name: 'Google Cloud'
    },
    {
      image: require("./assets/images/docker.svg"),
      name: 'Docker'
    },
    {
      image: require("./assets/images/kube.svg"),
      name: 'Kubernetes'
    }
  ]
}

// Your education background

const educationInfo = {
  viewEducation: true, // Set it to true to see education section
  schools: [
    {
      schoolName: "University of Abuja",
      logo: require("./assets/images/uofa.jpeg"),
      subHeader: "MSc. Computer Science",
      duration: "2022 - 2024",
      desc: "In progress."
    },
    {
      schoolName: "Umaru Musa Yar'adua University, Katsina",
      logo: require("./assets/images/umyu.jpg"),
      subHeader: "BSc. Computer Science",
      duration: "2011 - 2016",
      desc: "Studied the theoretical foundations of information and computation, taking a scientific and practical approach to computation and its applications in the fields of software engineering, network engineering, operating system, distributed systems, cryptography and artificial intelligence.",
      descBullets: [
        "Earned first class honor",
        "Built an android application that allows students and prospectives read information related to the university, calculate and save their GPA/CGPA point and keep track of their improvement and also share stories with the campus community."
      ]
    },
    {
      schoolName: "Udacity",
      logo: require("./assets/images/udacity.png"),
      subHeader: "Nanodegree in Cloud Computing",
      duration: "2020 - 2021",
      desc: "Udacity Nanodegree cloud development program covering AWS, Micorservices, Serverless Architecture and Kubernetes.",
      descBullets: [
        "Built microservice applications hosted on AWS Kubernetes Service",
        "Bult serverless application using AWS Lambda"
      ]
    }
  ]
}

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",  //Insert stack or technology you have experience in
      progressPercentage: "95%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Dev Ops",
      progressPercentage: "90%"
    },
    {
      Stack: "Cloud Computing",
      progressPercentage: "90%"
    },
    {
      Stack: "Machine Learning & AI",
      progressPercentage: "70%"
    },
    {
      Stack: "Frontend",
      progressPercentage: "80%"
    },
    {
      Stack: "Mobile",
      progressPercentage: "70%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Function Lead - Software Engineering",
      company: "Qore Technologies",
      companylogo: require("./assets/images/qore.png"),
      date: "July 2024 – August 2025",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Software Engineer II",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoft.png"),
      date: "June 2022 – Sept 2024",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Zedcrest Group",
      companylogo: require("./assets/images/zedcrest.png"),
      date: "March 2021 – June 2022",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Founder - CTO",
      company: "Techbay Solutions",
      companylogo: require("./assets/images/techbay.png"),
      date: "July 2020 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "EpayPlus Limited",
      companylogo: require("./assets/images/epayplus.png"),
      date: "May 2019 – December 2020",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Software Developer",
      company: "NexTekk LLC.",
      companylogo: require("./assets/images/nextekk.PNG"),
      date: "April 2018 – May 2019",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Developer",
      company: "Eloksware Limited",
      companylogo: require("./assets/images/eloksware.PNG"),
      date: "May 2016 – February 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "benyusouf", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME BIG PROJECTS I LED OR PARTICIPATED IN BUILDING",
  projects: [
    {
      name: 'Cashelio',
      description: "Cashelio is a trust-first, interest-free financial platform that helps people lend, save, and transact securely through digital wallets, P2P loans, group savings (Ajo), and smart escrow services.",
      image: require("./assets/images/cashelio.svg"),
      link: [{name: "check it out", url: "http://cashelio.com"}]
    },
    {
      name: 'SecurePlus',
      description: "SecurePlus is an AI-based security application developed to allow users report emergencies.",
      image: require("./assets/images/secureplus.png"),
      link: [{name: "check it out", url: "http://secureplus.netlify.app"}]
    },
    {
      name: 'Quickraiz',
      description: "Quickraiz is the leading local crowdfunding and fundraising platform in Nigeria.",
      image: require("./assets/images/quickraiz.jpg"),
      link: [{name: "check it out", url: "http://quickraiz.com"}]
    },
    {
      name: 'NexQuiz',
      description: "NexQuiz is a global intelligent software program that allows you to create quizzes to build the concept of a learner.",
      image: require("./assets/images/nexquiz.png"),
      link: [{name: "check it out", url: "http://nexquiz.com"}]
    },
    {
      name: 'Haskaar',
      description: "Haskaar is an instant messenger through which any users connect with any selected service provider on the network with easy.",
      image: require("./assets/images/haskaar.jpg"),
      link: [{name: "check it out", url: "https://apkpure.com/haskaar/com.eloksware.askaarmobile.askaarmobile"}]
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, and Some Cool Stuff that I have done!",

  achievementsCards: [
    // {
    //   title: "Cloud Developer - Nanodegree",
    //   subtitle: "Udacity Nanodegree cloud development program covering AWS, Micorservices, Serverless Architecture and Kubernetes.",
    //   image: require("./assets/images/udacity.png"),
    //   footerLink: [{ name: "Certificate", url: "https://drive.google.com/file/d/1TyDrVGSOHx_aT0_P4EYPdLGCj8q660PB/view?usp=sharing" }]
    // },
    {
      title: "Google Mobile Web Specialist",
      subtitle: "Selected among the top 500 candidates to receive the scholarship and graduated among the top 100 students in Africa.",
      image: require("./assets/images/mobileweb.jpeg"),
      footerLink: [
        { name: "Certification", url: "https://drive.google.com/file/d/1N_J5rnVs3eShxF9ksvxkjVlX25shZk3a/view?usp=sharing" },
        // { name: "Award Letter", url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing" },
        // { name: "Google Code-in Blog", url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html" }
      ]
    },
    {
      title: "API Designer",
      subtitle: "completed a course on API design and API security at API Academy. This course covers priciples of API development and management.",
      image: require("./assets/images/academy.jpg"),
      footerLink: [{ name: "Certificate", url: "https://drive.google.com/file/d/1PDV_UuchHmKx8SNOmWDt1gkaW_xVLPZo/view?usp=sharing" }]
    },
    {
      title: "AWS Dev Day",
      subtitle: "Attended Amazon Web Service program on Modern Application Development.",
      image: require("./assets/images/aws.png"),
      footerLink: [{ name: "Certification", url: "https://drive.google.com/file/d/1wwA2OzJ9d3lFsTTPUk89tUJKpEBBx_Jr/view?usp=sharing" }]
    },

    {
      title: "DevOps Practices Principles",
      subtitle: "Completed a course on Dev Ops Practices and Principles using Microsoft Azure DevOps.",
      image: require("./assets/images/dignig.png"),
      footerLink: [
        { name: "Certification", url: "https://drive.google.com/file/d/1Da8jAE2B0DnZSXFdN6_oFCF0Jx3INTHc/view?usp=sharing" },
      ]
    },
    // {
    //   title: "Big Data - HDInsight",
    //   subtitle: "Completed course on Data Series Analytics Big Data Hadoop On HDInsight.",
    //   image: require("./assets/images/dignig.png"),
    //   footerLink: [{ name: "Certification", url: "https://drive.google.com/file/d/1LCkJBk08nUVPIc4WPhknIcP6ULmWSAA9/view?usp=sharing" }]
    // },
    {
      title: "Diploma in DBMS",
      subtitle: "Completed diploma in database administration and management Oracle 11g under the supervision of The Mistry of Information, Federal Republic of Nigeria.",
      image: require("./assets/images/ministry.jpg"),
      footerLink: [
        { name: "Certification", url: "https://drive.google.com/file/d/1jZc-l-tsP12T64qn3mlowaU95s9aqYli/view?usp=sharing" },
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://benyusouf.medium.com/why-you-should-adapt-onion-architecture-in-your-c-applications-f12c5283791f",
      title: "Why you should adapt onion architecture in your C# applications",
      description: "The idea of the Onion Architecture is to place the Domain and Services Layers at the center of your application. And externalize the Presentation and Infrastructure."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Have a project you want us to discuss about or just want to say hi? My Inbox is open for all.",
  number: "+2348060881434",
  email_address: "abdul.benyusouf@gmail.com"
};

//Twitter Section

const twitterDetails = {

  userName : "benyusouf"

};
export { moreSkills, logo, greeting, socialMediaLinks, skillsSection, educationInfo, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo , twitterDetails, illustration, splashAnimation, splashScreen};
